const updateSingleNotificationFetch = (id, type, event):string => `
	{
        notifications {
          updateSingleNotificationItemState(id: ${id}, type: "${type}", event: "${event}")
        }
    }
`;

export default updateSingleNotificationFetch;
